module.exports = require("core-js/modules/es.json.to-string-tag.js");